const isLurkerOnPage = () => {
    if (typeof window === 'undefined')
        return false;
    return !!window.Lurker;
};
/**
 * Componente Lurker do Design System OLX
 */
export const sendToLurker = ({ eventType, objectDetail, objectName, data }) => {
    var _a, _b, _c;
    if (!isLurkerOnPage())
        return;
    const isBrowser = () => ![typeof window, typeof document].includes('undefined');
    const isMobile = isBrowser() ? (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.site) === null || _c === void 0 ? void 0 : _c.isMobile : false;
    const payload = {
        event_type: eventType,
        object_detail: objectDetail,
        object_name: objectName,
        source: isMobile ? 'msite' : 'web',
        data: data || {},
    };
    window.Lurker.sendBeacon(payload, 'https://lurker.olx.com.br/track');
};
